import { styled } from "@vebox/etui-system";
import { Ul } from "@vebox/etui-system-elements";

export const MenuUl = styled(Ul)`
  padding: 0;
  margin: 0;
  list-style: none;
`;
